<template>
  <div>
    <el-dialog
        :title="title"
        :visible.sync="open"
        :modal-append-to-body="true"
        top="100px"
        width="60%"
        custom-class="addClass"
        @open="openHandler"
        :destroy-on-close="true"
        :before-close="handleClose">

      <template #default>

        <el-form ref="form" label-width="110px" :model="form" :rules="rules">
          <el-form-item label="问题内容" prop="question">
            <el-input v-model="form.question" clearable placeholder="请输入问题内容"></el-input>
          </el-form-item>
          <el-form-item label="问题回复" prop="answer">
            <RichText v-model="form.answer" />
          </el-form-item>
          <el-form-item label="问题排序" prop="sort">
            <el-input v-model="form.sort" clearable placeholder="请输入问题在小程序的排列顺序，例：6"></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="status">
            <el-radio-group v-model="form.status">
              <template v-for="(item, index) in statusList">
                <el-radio :key="index" :label="item.value">{{
                    item.label
                  }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </template>

      <div slot="footer" class="dialog-footer">
        <div v-if="id">
          <el-popconfirm
                style="margin-left: 10px;"
                title="删除后将不可取消，小程序将不再显示该答疑，确定删除吗？"
                @confirm="delHandler(id)">
                <el-button slot="reference"  size="small" >删除</el-button>
            </el-popconfirm>
        </div>
        <div>
          <el-button size="small" @click="handleClose(onCancel)">取 消</el-button>
          <el-button type="primary" size="small" @click="onConfirm">提交</el-button>
        </div>
      </div>
        <!-- 删除确认弹窗 -->
    </el-dialog>
  </div>
    
</template>

<script>
import RichText from "@/components/RichText/index";

export default {
  name: "AddQuestionAnsweringManagement",
  components: {
    RichText,
  },
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    id: {
      type: [String,Number],
      default: () => ""
    },
  },
  data() {
    return {
      form: {
        question: "",
        answer: "",
        sort: "",
        status: 1,
      },
      rules: {
        question: [
          { required: true, message: '此项为必填项', trigger: 'blur' },
          { min: 5, max: 200, message: '问题内容长度必须在5到200个字符之间', trigger: 'blur' },
        ],
        answer: [
          { min: 10, max: 2000, message: '问题内容长度必须在10到2000个字符之间', trigger: 'blur' },
        ],
        sort: [
          { pattern: /^[1-9]\d*$/, message: '请输入数字', trigger: 'blur' }
        ]
      },
      statusList: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
    }
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input",val);
      },
    },
    title() {
      let str = "新增";
      if (this.id) {
        str = "编辑";
      }
      return `${str}答疑`;
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    openHandler() {
      if (this.id) this.getDetails();
    },
    async getDetails() {
      try {
        const res = await this.$get("qa/findById", {
          id: this.id
        })
        if (!res) return false;
        const { data } = res;
        this.form.question = data.question;
        this.form.answer = data.answer;
        this.form.sort = data.sort;
        this.form.status = data.status;
      }catch (e) {
        console.error(`获取详情失败`, e);
      }
    },
    onConfirm() {
      this.$refs["form"].validate(async (valid) => {
        if(valid) {
          try {
            const res = await this.$post("qa/save", {
              id: this.id,
              ...this.form,
            });
            if (!res) return false;
            this.$emit("updateList");
            this.handleClose(this.onCancel);
          }catch (e) {
            console.error(`保存失败`, e);
          }
        }
      })
    },
    onCancel() {
      this.open = false;
    },
    handleClose(done) {
      this.$refs["form"].resetFields();
      done();
    },
    delHandler() {
      this.$emit("delHandler", {id: this.id});
      this.handleClose(this.onCancel);
    }
  },
}
</script>

<style scoped lang="scss">
.dialog-footer {
  display: flex;
  justify-content: space-between;
  div {
    width: fit-content;
  }
}
</style>
